export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11244.2e7a6d37.jpg";